module.exports = __webpack_public_path__ + "img/1.efa29dc2.png";